import styled, { css } from 'styled-components';

export const FilterSearchDynamicStyled = styled.div`
  background: white;
  border-radius: 8px;
  width: 100%;
`;

export const SuggestionContent = styled.div`
  padding: 8px 16px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  border-radius: 16px;
  align-items: center;
`;

export const AutocompleteSuggestionIcon = styled.div<{ iconImage?: string }>`
  margin-right: 8px;
  background-color: #f2f2f3;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  flex-shrink: 0;

  ${({ iconImage }) =>
    iconImage &&
    css`
      background-image: url(${iconImage});
    `}
`;

export const AutocompleteSuggestionLabel = styled.div`
  width: calc(100% - 80px);
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  font-size: ${({ theme }) => theme.kallisto.font.size['200']};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;

  span:nth-child(2) {
    color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  }

  flex-direction: column;
  span {
    width: 100%;
    display: flex;
    &:last-of-type {
      font-size: 12px;
    }
  }
`;

export const AutocompleteSuggestionCheck = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  color: ${({ theme }) => theme.kallisto.color.common.black[0]};
  svg .selected {
    fill: ${({ theme }) => theme.kallisto.color.background.static.backgroundNeutralSubtle};
  }
  svg .unselected {
    fill: ${({ theme }) => theme.kallisto.color.background.static.backgroundPage};
    stroke: ${({ theme }) => theme.kallisto.color.common.black[100]};
    stroke-width: 1px;
  }
`;

export const FilterSearchDynamicModalStyled = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.kallisto.color.background.static.backgroundLayer01};
  z-index: 10000;
  pointer-events: auto;
`;

export const FilterSearchDynamicModalTitleStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  background-color: white;
`;

export const FilterSearchDynamicModalCloseStyled = styled.div`
  cursor: pointer;
  padding: 18px;
  z-index: 10;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
`;

export const FilterSearchDynamicModalTitleNameStyled = styled.div`
  position: absolute;
  top: 14px;
  left: 50%;
  transform: translate(-50%);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
`;

export const FilterSearchDynamicMobileButton = styled.button<{ showDeleteButton: boolean }>`
  border: 0;
  margin: 0 0 0 8px;
  padding: 0;
  font-style: normal;
  font-weight: 400;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  line-height: 24px;
  color: #8c8c92;
  background: transparent;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  ${({ showDeleteButton }) =>
    showDeleteButton &&
    css`
      padding-right: 32px;
    `}
`;

export const FilterSearchDynamicMobile = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.kallisto.color.common.black['50']};
  border-radius: 8px;
  padding: 14px 16px;
`;

export const FilterSearchDynamicDelete = styled.button`
  position: absolute;
  top: 25px;
  transform: translateY(-50%);
  right: 16px;
  height: 16px;
  z-index: 10;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;

  [data-library-icon] {
    color: ${({ theme }) => theme.kallisto.color.common.black[200]};
    transition: color 0.2s ease;
  }

  &:hover {
    [data-library-icon] {
      color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
    }
  }
`;
